<div class="container-fluid px-0 min-vh-100 compliance-management-page">
  <div v-if="current_view === 'hub'" class="d-flex flex-column gap-4 gap-lg-3 mx-auto">
    <section class="entity-config-top rounded-4 overflow-hidden border-0 mt-2">
      <div class="entity-config-top-hero px-2 px-md-2 py-2">
        <div class="row -2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Compliance Management Hub</h1>
            <p class="entity-page-subtitle text-white mb-0">Create, manage, and configure compliance rules, forms, and assigned questions.</p>
          </div>
          <div class="col-auto d-flex justify-content-end">
            <button type="button" class="btn btn-primary-dark text-xs d-inline-flex align-items-center rounded-3 px-3 py-2 shadow-sm me-2 align-self-end" data-bs-toggle="modal" data-bs-target="#compliance_rule_modal" @click="open_rule_modal()">
              <i class="bi bi-plus-circle-fill me-2"></i><span>Create Compliance Rule</span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="entity-inventory-panel compliance-rules-panel rounded-4 border shadow-sm p-2">
      <div class="row g-2 align-items-start align-items-lg-center mb-3">
        <div class="col-12 col-lg">
          <div class="d-flex align-items-center gap-3">
            <div class="entity-section-icon rounded-3 d-inline-flex align-items-center justify-content-center"><i class="bi bi-shield-check"></i></div>
            <div>
              <div class="entity-section-title fw-bold fs-6">Compliance Rules</div>
              <div class="text-secondary text-xxs">Rules are created first, then forms and questions are assigned to each rule.</div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-auto">
          <div class="d-grid d-sm-flex align-items-stretch gap-2">
            <div class="d-inline-flex align-items-center gap-2">
              <i class="bi bi-funnel-fill"></i>
              <select v-model="hub_filter" class="form-select form-select-sm rounded-small">
                <option value="all">All</option><option value="active">Active</option><option value="needs_questions">Needs Questions</option><option value="needs_forms">Needs Forms</option><option value="recurring">Recurring</option><option value="onboarding">Onboarding</option><option value="ongoing">Ongoing</option>
              </select>
            </div>
            <div class="d-inline-flex align-items-center gap-2">
              <i class="bi bi-sort-down"></i>
              <select v-model="hub_sort_order" class="form-select form-select-sm rounded-small">
                <option value="updated_desc">Newest Updated</option><option value="updated_asc">Oldest Updated</option><option value="most_questions">Most Questions</option><option value="most_forms">Most Forms</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loading" class="d-flex align-items-center gap-2 text-secondary text-xs py-2">
        <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div><span>Loading compliance rules...</span>
      </div>

      <div v-else-if="displayed_rules.length" class="compliance_rules_list">
        <div class="compliance_rules_header">
          <span>Compliance Rule</span>
          <span>Evaluation Logic</span>
          <span>Schedule</span>
          <span>Configuration</span>
          <span>Status</span>
          <span>Actions</span>
        </div>
        <article v-for="rule in displayed_rules" :key="rule.id" class="entity-row-card compliance_rule_row bg-white rounded-4 border shadow-sm">
          <div class="compliance_rule_cell compliance_rule_identity">
            <div class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center"><i class="bi bi-shield-lock"></i></div>
            <div class="compliance_rule_copy">
              <div class="entity-name fw-bold">{{ rule.name }}</div>
              <div class="entity-updated text-secondary">{{ rule.description || 'No description provided.' }}</div>
              <div class="compliance_rule_meta">Created by {{ rule.created_by }} | {{ rule.updated_label }}</div>
            </div>
          </div>

          <div class="compliance_rule_cell compliance_rule_logic" data-label="Evaluation Logic">
            <div class="compliance_badge_group">
              <span class="badge rounded-pill bg-primary-subtle text-primary px-2 py-1">{{ rule.logic }}</span>
              <span class="badge rounded-pill bg-light text-dark border px-2 py-1">{{ rule.trigger_status_label || 'No trigger' }}</span>
            </div>
            <span class="badge rounded-pill compliance_health_badge" :class="health_badge_class(rule.health_status)">{{ rule.health_status }}</span>
          </div>

          <div class="compliance_rule_cell compliance_rule_schedule" data-label="Schedule">
            <span class="badge rounded-pill compliance_mode_badge" :class="Number(rule.frequency_days) ? 'bg-info-subtle text-primary' : 'bg-light text-dark border'">{{ rule.rule_mode }}</span>
          </div>

          <div class="compliance_rule_cell compliance_rule_config" data-label="Configuration">
            <span class="badge rounded-pill bg-light text-dark border compliance_metric_pill">{{ rule.assigned_forms_count }} Forms</span>
            <span class="badge rounded-pill bg-light text-dark border compliance_metric_pill">{{ rule.assigned_questions_count }} Questions</span>
          </div>

          <div class="compliance_rule_cell compliance_rule_status" data-label="Status">
            <span class="entity-status-pill fw-bold text-uppercase" :class="status_badge_class(rule.status)">{{ rule.status }}</span>
          </div>

          <div class="compliance_rule_cell compliance_rule_actions">
            <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1" @click="open_rule_builder(rule)">Edit</button>
            <button type="button" class="entity-row-arrow rounded-circle d-inline-flex align-items-center justify-content-center" @click="open_rule_builder(rule)"><i class="bi bi-chevron-right fs-6"></i></button>
          </div>
        </article>
      </div>

      <div v-else class="card border-0 shadow-sm rounded-4">
        <div class="card-body p-4 p-lg-5 d-flex flex-column align-items-center justify-content-center text-center gap-3">
          <div class="entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center p-4"><i class="bi bi-inbox fs-1 opacity-75"></i></div>
          <div><p class="fw-bold text-x mb-1">No compliance rules created yet</p><p class="text-secondary text-xs mb-0">No compliance rules created yet. Create your first rule to start configuring compliance.</p></div>
          <button type="button" class="btn btn-primary-dark text-xs shadow d-inline-flex align-items-center" data-bs-toggle="modal" data-bs-target="#compliance_rule_modal" @click="open_rule_modal()"><i class="bi bi-plus-circle-fill me-2"></i>Create Compliance Rule</button>
        </div>
      </div>
    </section>
  </div>

  <div v-else class="d-flex flex-column gap-3 pb-4">
    <section class="entity-config-top rounded-4 overflow-hidden border-0 mt-2">
      <div class="entity-config-top-hero px-2 px-md-2 py-2">
        <div class="d-flex flex-column flex-xl-row justify-content-between gap-3">
          <div>
            <div class="text-white-50 text-xxs mb-1">Configuration &gt; Compliance &gt; {{ selected_rule ? selected_rule.name : 'Rule Builder' }}</div>
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <h1 class="entity-page-title text-white fw-bold lh-sm mb-0">Compliance Management</h1>
              <span class="badge rounded-pill px-3 py-2" :class="selected_rule ? status_badge_class(selected_rule.status) : 'workflow-status-pending'">{{ selected_rule ? selected_rule.status : 'Draft' }}</span>
            </div>
            <p class="entity-page-subtitle text-white mb-0 mt-1">{{ selected_rule ? `Configure ${selected_rule.name}` : 'Configure compliance rules, forms, questions, conditions, and ongoing evaluation.' }}</p>
          </div>
        </div>
      </div>
    </section>

    <section v-if="selected_rule" class="card border-0 rounded-4 shadow-sm compliance-builder-shell">
      <div class="card-body p-3 p-lg-4">
      <div class="rule-builder-tabs-card compliance-progress-header">
        <div class="p-3">
          <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-2">
            <div>
              <p class="workflow-summary-label mb-1">Step {{ active_setup_step.number }} of {{ setup_steps.length }}</p>
              <h2 class="fw-bold text-x mb-1">{{ active_setup_step.label }}</h2>
            </div>
            <div class="inline-status-strip">
              <span class="inline-status-item text-success"><i class="bi bi-check-circle-fill"></i>{{ completed_setup_steps_count }} complete</span>
              <span class="inline-status-item" :class="onboarding_gate_complete ? 'text-success' : 'text-warning'"><i class="bi" :class="onboarding_gate_complete ? 'bi-check-circle-fill' : 'bi-exclamation-triangle-fill'"></i>{{ onboarding_gate_complete ? 'Onboarding ready' : 'Onboarding needs setup' }}</span>
              <span class="inline-status-item" :class="conditions_complete ? 'text-success' : 'text-secondary'"><i class="bi" :class="conditions_complete ? 'bi-check-circle-fill' : 'bi-circle'"></i>Conditions {{ conditions_complete ? 'ready' : 'next' }}</span>
            </div>
          </div>
          <div class="d-flex flex-nowrap gap-2 border-bottom overflow-auto workflow-stepper-tabs pb-3">
            <button
              v-for="step in setup_steps"
              :key="step.id"
              type="button"
              class="btn btn-sm rounded-pill px-3 workflow-step-tab compliance-step-tab"
              :class="[active_rule_tab === step.id ? 'workflow-step-tab-active' : 'workflow-step-tab-inactive', !step.unlocked ? 'guided-step-locked' : '']"
              :disabled="!step.unlocked"
              @click="set_active_rule_tab(step.id)"
            >
              {{ step.number }}. {{ step.short_label || step.label }}
            </button>
          </div>
        </div>
      </div>

      <div class="row g-4 align-items-stretch compliance_builder_workspace">
      <main class="col-12 col-xl-8 d-flex compliance_builder_main">
        <div class="d-flex flex-column gap-3 h-100 w-100">
          <section v-if="active_rule_tab === 'rule_setup'" class="rule-section rule-setup-card card h-100 w-100 border rounded-4 shadow-sm">
            <div class="card-body p-4">
              <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-3 rule-setup-heading">
                <div><p class="workflow-summary-label mb-1">Step 1</p><h2 class="fw-bold text-x mb-1">Rule Setup</h2><p class="text-secondary text-xs mb-0">Configure rule metadata first. Forms and conditions unlock after this is valid.</p></div>
                <span class="badge rounded-pill text-xxs" :class="step_badge_class(active_setup_step.status)">{{ active_setup_step.status }}</span>
              </div>
              <div class="rule-info-banner mb-3">{{ next_evaluation_label }}</div>
              <div class="row g-3 rule-setup-form">
                <div class="col-12 col-md-6"><label class="workflow-summary-label mb-1">Rule Name</label><input v-model="rule_form.name" class="form-control workflow-config-select text-xs"></div>
                <div class="col-12 col-md-6"><label class="workflow-summary-label mb-1">Logic</label><select v-model="rule_form.logical_operator" class="form-select workflow-config-select text-xs"><option v-for="operator in operators" :key="operator">{{ operator }}</option></select></div>
                <div class="col-12"><label class="workflow-summary-label mb-1">Description</label><textarea v-model="rule_form.description" rows="3" class="form-control text-xs"></textarea></div>
                <div class="col-12 col-md-6"><label class="workflow-summary-label mb-1">Trigger Status</label><select v-model="rule_form.trigger_status_id" class="form-select workflow-config-select text-xs"><option value="">Select trigger status</option><option v-for="status in form_statuses" :key="status.id" :value="String(status.id)">{{ status.status || status.name || `Status ${status.id}` }}</option></select></div>
                <div class="col-12 col-md-2"><label class="workflow-summary-label mb-1">Initial Grace Days</label><input v-model.number="rule_form.initial_grace_period_days" type="number" min="0" class="form-control text-xs"></div>
                <div class="col-12 col-md-2"><label class="workflow-summary-label mb-1">Frequency Days</label><input v-model.number="rule_form.frequency_days" type="number" min="0" class="form-control text-xs"></div>
                <div class="col-12 col-md-2"><label class="workflow-summary-label mb-1">Recurring Grace</label><input v-model.number="rule_form.recurring_grace_period_days" type="number" min="0" class="form-control text-xs"></div>
              </div>
              <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 border-top pt-3 mt-4">
                <span></span>
                <button type="button"  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" :disabled="saving" @click="save_rule_setup_step">{{ saving ? 'Saving...' : 'Save Rule Setup' }}</button>
              </div>
            </div>
          </section>

          <section v-else-if="active_rule_tab === 'conditions'" class="rule-section card h-100 w-100 border rounded-4 shadow-sm">
            <div class="card-body p-3 p-lg-4">
              <div class="d-flex justify-content-between align-items-start gap-3 mb-3 flex-wrap">
                <div><p class="workflow-summary-label mb-1">Step 4</p><h2 class="fw-bold text-x mb-1">Conditions</h2><p class="text-secondary text-xs mb-0">You only need conditions for answers that determine compliance outcomes.</p></div>
                <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" :disabled="!selected_rule_forms.length || !selected_rule_questions.length" @click="add_condition_group"><i class="bi bi-plus-lg me-2"></i>Add Condition</button>
              </div>
              <div v-if="!selected_rule_forms.length || !selected_rule_questions.length" class="card border rounded-4 bg-white bg-opacity-75 mb-3"><div class="card-body py-5 text-center text-secondary text-xs">Assign forms and questions before creating conditions.</div></div>
              <div v-else-if="!condition_groups.length" class="card border rounded-4 bg-white bg-opacity-75 mb-3"><div class="card-body py-5 text-center text-secondary text-xs">No conditions configured yet. Add conditions to define how this rule evaluates compliance answers.</div></div>
              <div v-else class="d-flex flex-column gap-3 mb-3">
                <article v-for="(group, index) in condition_groups" :key="group.id" class="condition-table-card">
                  <div class="condition-table-layout">
                    <div class="condition-table-main">
                      <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
                        <h3 class="fw-bold text-xs mb-0">{{ condition_group_name(group, index) }} — {{ group.logic || 'AND' }}</h3>
                        <span class="badge rounded-pill bg-primary-subtle text-primary px-2 py-1">{{ condition_count_for_group(group) }} condition{{ condition_count_for_group(group) === 1 ? '' : 's' }} configured</span>
                      </div>
                      <div class="condition-table-body">
                        <template v-for="(row, row_index) in condition_table_rows(group)" :key="`${group.id}-${row.number}-${row.question}`">
                          <div class="condition-table-row">
                            <span class="condition-row-number">{{ row.number }}</span>
                            <span class="condition-row-question" :title="row.question">{{ row.question }}</span>
                            <span class="condition-row-operator">{{ row.operator }}</span>
                            <span class="condition-value-pill"><i class="bi bi-input-cursor-text"></i>{{ row.value }}</span>
                          </div>
                          <div v-if="row_index < condition_table_rows(group).length - 1" class="condition-logic-divider">
                            <span>{{ group.logic || 'AND' }}</span>
                          </div>
                        </template>
                      </div>
                      <div class="condition-table-preview">
                        <span class="condition-preview-icon"><i class="bi bi-eye"></i></span>
                        <p class="text-xs mb-0">{{ condition_preview_sentence(group) }}</p>
                      </div>
                    </div>
                    <div class="condition-card-actions">
                      <button type="button"  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-1 py-1 mt-1 text-xs d-inline-flex align-items-center gap-2 px-1 py-1" @click="open_condition_group_modal(group)"><i class="bi bi-pencil"></i>Edit</button>
                      
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </section>

          <section v-else-if="active_rule_tab === 'actions'" class="rule-section card h-100 w-100 border rounded-4 shadow-sm">
            <div class="card-body p-3 p-lg-4">
              <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-3">
                <div><p class="workflow-summary-label mb-1">Step 5</p><h2 class="fw-bold text-x mb-1">Actions</h2><p class="text-secondary text-xs mb-0">Define what happens after compliance evaluation for pass, fail, manual review, expired, and missing data outcomes.</p></div>
                <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" :disabled="!conditions_complete" @click="open_action_modal()"><i class="bi bi-plus-lg me-2"></i>Add Action</button>
              </div>
              <div v-if="!conditions_complete" class="card border rounded-4 bg-white bg-opacity-75 mb-3"><div class="card-body py-5 text-center text-secondary text-xs">Configure conditions before choosing result actions.</div></div>
              <div v-else-if="!configured_actions.length" class="card border rounded-4 bg-white bg-opacity-75 mb-3"><div class="card-body py-5 text-center text-secondary text-xs">No actions configured yet. Add an action to decide what happens after evaluation.</div></div>
              <div v-if="configured_actions.length" class="d-flex flex-column gap-2">
                <article v-for="action in configured_actions" :key="action.id" class="compliance-action-card">
                  <div class="compliance-action-main">
                    <div class="action-icon compliance-action-icon"><i class="bi" :class="action.icon"></i></div>
                    <div class="compliance-action-copy">
                      <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
                        <h3 class="compliance-action-title mb-0">{{ action.action }}</h3>
                        <span class="compliance-action-status">Active</span>
                      </div>
                      <p class="compliance-action-trigger mb-1">When compliance result = {{ action_outcome_label(action) }}</p>
                      <p class="compliance-action-description mb-2">{{ action_description(action) }}</p>
                      <div class="d-flex flex-wrap gap-2">
                        <span class="compliance-action-pill compliance-action-pill-outcome">Outcome: {{ action_outcome_label(action) }}</span>
                        <span class="compliance-action-pill" :class="action_severity_badge_class(action.priority)">Severity: {{ action.priority || 'Medium' }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="compliance-action-controls">
                    <button type="button" class="btn entity-assign-btn btn-sm rounded-circle py-2 ms-2" title="Edit Action" aria-label="Edit Action" @click="open_action_modal(action)"><i class="bi bi-pencil"></i></button>
                    <button type="button" class="btn btn-outline-danger btn-sm rounded-circle" title="Delete Action" aria-label="Delete Action" @click="remove_action_config(action.id)"><i class="bi bi-trash3"></i></button>
                  </div>
                </article>
              </div>
            </div>
          </section>

          <section v-else-if="active_rule_tab === 'assignments'" class="rule-section card h-100 w-100 border rounded-4 shadow-sm">
            <div class="card-body p-3 p-lg-4">
              <p class="workflow-summary-label mb-1">Assignments</p>
              <h2 class="fw-bold text-x mb-2">Assign Rule Ownership</h2>
              <input v-model="assignment_search" class="form-control workflow-config-select mb-3" placeholder="Search users, teams, departments, or roles">
              <div class="row g-2">
                <div v-for="target in ['Users', 'Teams', 'Departments', 'Roles']" :key="target" class="col-12 col-md-6">
                  <div class="card border rounded-4 shadow-sm h-100">
                    <div class="card-body p-3">
                      <div class="d-flex justify-content-between align-items-center gap-2 mb-2">
                        <p class="fw-bold text-xs mb-0">{{ target }}</p>
                        <button type="button" class="btn btn-outline-primary btn-sm rounded-pill" @click="add_assignment_target(target)">Add</button>
                      </div>
                      <p class="text-secondary text-xxs mb-2">Role-based editing, review responsibility, and publish approval ownership.</p>
                      <div class="d-flex flex-wrap gap-2">
                        <span v-for="assignment in assignment_targets.filter((item) => item.type === target)" :key="assignment.id" class="badge rounded-pill bg-primary-subtle text-primary">
                          {{ assignment.name }} <button type="button" class="btn btn-link btn-sm p-0 ms-1 text-primary" @click="remove_assignment_target(assignment.id)">x</button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" @click="save_assignments">Save Assignments</button>
            </div>
          </section>

          <section v-else-if="active_rule_tab === 'forms_questions'" class="rule-section card h-100 w-100 border rounded-4 shadow-sm">
            <div class="card-body p-3 p-lg-4">
              <div class="container-fluid w-100 px-0">
              <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-3">
                <div>
                  <p class="workflow-summary-label mb-1">Step 2 of 7</p>
                  <h2 class="fw-bold text-x mb-1">Forms & Questions</h2>
                  <p class="text-secondary text-xs mb-0">Choose the form data and questions this compliance rule can evaluate.</p>
                </div>
                <span class="badge rounded-pill" :class="step_badge_class(active_setup_step.status)">{{ active_setup_step.status }}</span>
              </div>

              <div class="compact-metrics-strip rounded-4 p-3 mb-4 w-100">
                <div class="row g-3 w-100">
                  <div v-for="metric in forms_question_summary_cards" :key="metric.label" class="col-12 col-md">
                    <div class="compact-metric-item h-100 w-100">
                      <span class="workflow-summary-label d-block mb-1">{{ metric.label }}</span>
                      <strong class="text-xs">{{ metric.value }}</strong>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-grid gap-4 compliance_primary_column w-100">
                  <section class="guided-work-block mb-4 w-100">
                    <div class="row g-3 align-items-end w-100">
                    <div class="col-12">
                      <div class="mb-2">
                        <p class="workflow-summary-label mb-1">1. Add a form</p>
                        <p class="text-secondary text-xxs mb-0">Choose a form to make its questions available for this compliance rule.</p>
                      </div>
                      <div class="row g-2 w-100">
                        <div class="col-12 col-md-8">
                          <select v-model="selected_form_id" class="form-select workflow-config-select w-100">
                            <option value="" disabled>Select a form</option>
                            <option v-for="form in assignable_entity_type_forms" :key="form.id" :value="String(form.id)">{{ form.form_name }}</option>
                          </select>
                          <p v-if="!entity_type_forms.length" class="text-secondary text-xxs mb-0 mt-1">No forms are available for assignment yet.</p>
                          <p v-else-if="!assignable_entity_type_forms.length" class="text-secondary text-xxs mb-0 mt-1">No forms are available for this entity type yet.</p>
                        </div>
                        <div class="col-12 col-md-4 d-grid">
                          <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" :disabled="assigning || !selected_form_id" @click="add_selected_form_to_rule">
                            {{ assigning ? 'Adding...' : 'Add Form' }}
                          </button>
                        </div>
                      </div>
                    </div>
                    </div>
                  </section>

                  <section v-if="selected_rule_forms.length" class="guided-work-block mb-4">
                    <div class="d-flex justify-content-between align-items-center gap-2 flex-wrap mb-3">
                      <div>
                        <p class="workflow-summary-label mb-1">2. Assigned Forms</p>
                        <p class="text-secondary text-xxs mb-0">Manage which questions from each assigned form this rule can use.</p>
                      </div>
                    </div>
                    <div class="assigned_forms_list">
                      <article v-for="form in selected_rule_forms" :key="form.form_id" class="assigned_form_card">
                        <div class="assigned_form_main">
                          <div class="action-icon assigned_form_icon"><i class="bi bi-ui-checks-grid"></i></div>
                          <div class="min-w-0">
                            <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
                              <p class="fw-bold text-xs mb-0">{{ form.form_name }}</p>
                              <span class="badge rounded-pill" :class="health_badge_class(form.health_status)">{{ form.health_status }}</span>
                            </div>
                            <div class="assigned_form_metrics">
                              <span><strong>{{ form.assigned_questions_count }}</strong> questions selected</span>
                              <span><strong>{{ form.total_questions_count }}</strong> available</span>
                            </div>
                            <div v-if="assigned_questions_for_form(form.form_id).length" class="assigned-section-summary mt-2">
                              <span v-for="section in assigned_questions_by_section_for_form(form).slice(0, 3)" :key="`${form.form_id}-${section.section_name}`">{{ section.section_name }} ({{ section.count }})</span>
                            </div>
                            <div v-if="assigned_question_names_for_form(form).length" class="mt-2">
                              <p class="workflow-summary-label mb-1">Selected Preview</p>
                              <div class="d-flex flex-wrap gap-1">
                                <span v-for="question_name in assigned_question_names_for_form(form).slice(0, 5)" :key="`${form.form_id}-${question_name}`" class="selected-question-chip" :title="question_name">{{ question_name }}</span>
                                <button v-if="assigned_question_names_for_form(form).length > 5" type="button" class="selected-question-chip selected-question-chip-muted border-0" @click="open_manage_form_questions_selected_only(form)">+{{ assigned_question_names_for_form(form).length - 5 }} more</button>
                              </div>
                            </div>
                            <div v-else class="subtle-empty-state rounded-4 text-center text-secondary text-xs mt-2">No specific questions selected yet.</div>
                          </div>
                        </div>
                        <div class="assigned_form_actions">
                          <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" @click="open_configure_form_questions(form)"><i class="bi bi-sliders"></i>Manage Questions</button>
                          <button type="button" class="btn assigned-form-remove-btn btn-sm rounded-small shadow-sm text-xs d-inline-flex align-items-center gap-2 px-3 py-2 text-nowrap" @click="remove_form_from_rule(form)"><i class="bi bi-trash3"></i>Remove Form</button>
                        </div>
                      </article>
                    </div>
                  </section>

              </div>
              </div>
            </div>
          </section>

          <section v-else-if="active_rule_tab === 'onboarding_gate'" class="rule-section card h-100 w-100 border rounded-4 shadow-sm onboarding-gate-restore">
            <div class="p-3 p-lg-4">
              <div class="onboarding-gate-heading">
                <div>
                  <p class="workflow-summary-label mb-1">Step 3</p>
                  <h2 class="fw-bold text-x mb-1">Onboarding Requirements</h2>
                  <p class="text-secondary text-xs mb-0">Choose which questions must be answered before onboarding can continue.</p>
                </div>
                <span class="badge rounded-pill" :class="step_badge_class(active_setup_step.status)">{{ active_setup_step.status }}</span>
              </div>

              <div class="onboarding-guided-flow">
                <section class="onboarding-workflow-card">
                  <div class="onboarding-card-main">
                    <div class="action-icon onboarding-card-icon"><i class="bi bi-clipboard-check"></i></div>
                    <div class="onboarding-card-content">
                      <div class="onboarding-card-header">
                        <div class="min-w-0">
                          <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
                            <h3 class="onboarding-section-title mb-0">Required Questions</h3>
                          </div>
                          <p class="onboarding-section-meta mb-0">{{ onboarding_required_questions.length }} of {{ selected_rule_questions.length }} questions required</p>
                        </div>
                        <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" :disabled="!selected_rule_questions.length" @click="open_required_questions_modal"><i class="bi bi-sliders"></i>Manage Questions</button>
                      </div>

                      <div v-if="onboarding_required_questions.length" class="assigned-section-summary mt-2">
                        <span v-for="group in onboarding_required_question_groups" :key="`gate-section-${group.name}`">{{ group.name }} ({{ group.questions.length }})</span>
                      </div>

                      <div v-if="!onboarding_required_questions.length" class="onboarding-empty-box text-secondary text-xs mt-2">No required questions selected.</div>
                      <div v-else class="required-question-preview compact-question-summary mt-2">
                        <div v-for="group in onboarding_required_question_groups" :key="`gate-group-${group.name}`" class="required-question-group required-category-preview">
                          <p class="question-group-label mb-1">{{ group.name }}</p>
                          <div class="selected-question-chip-list required-question-chip-list">
                            <span v-for="question in group.questions.slice(0, 4)" :key="`gate-summary-${question_key(question)}`" class="selected-question-chip" :title="question.question_text">{{ question.question_text }}</span>
                          </div>
                          <span v-if="group.questions.length > 4" class="inline-action-link">+{{ group.questions.length - 4 }} more</span>
                        </div>
                        <span v-if="onboarding_required_questions_more_count > 0" class="inline-action-link">+{{ onboarding_required_questions_more_count }} more</span>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="onboarding-workflow-card">
                  <div class="onboarding-card-main">
                    <div class="action-icon onboarding-card-icon onboarding-card-icon-soft"><i class="bi bi-lightning-charge"></i></div>
                    <div class="onboarding-card-content">
                      <div class="onboarding-card-header">
                        <div class="min-w-0">
                          <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
                            <h3 class="onboarding-section-title mb-0">Answer-based Requirements</h3>
                            <span class="badge rounded-pill bg-light text-dark border">Optional</span>
                            <span class="status-badge status-badge-muted">{{ onboarding_conditional_requirements.length }} rule{{ onboarding_conditional_requirements.length === 1 ? '' : 's' }}</span>
                          </div>
                        </div>
                        <button type="button"  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1":disabled="selected_rule_questions.length < 2" @click="open_conditional_requirement_modal()"><i class="bi bi-plus-lg"></i>Add Rule</button>
                      </div>

                      <div v-if="!onboarding_conditional_requirements.length" class="onboarding-empty-box text-secondary text-xs mt-2">No answer-based requirements yet.</div>
                      <div v-else class="conditional-rule-list mt-2">
                        <article v-for="requirement in onboarding_conditional_requirements.slice(0, 4)" :key="requirement.id" class="conditional-rule-summary compact-rule-card">
                          <div class="automation-rule-grid">
                            <div class="rule-summary-block">
                              <span class="rule-summary-label">If applicant answers</span>
                              <p class="mb-0 text-xs fw-semibold">"{{ question_label_by_id(requirement.trigger_question_id) }}" {{ requirement.operator || '=' }} "{{ requirement.trigger_value || 'value' }}"</p>
                            </div>
                            <div class="rule-summary-block">
                              <span class="rule-summary-label">Then require</span>
                              <ul class="question-bullet-preview rule-required-list mb-0">
                                <li v-for="question_id in conditional_required_question_ids(requirement)" :key="`conditional-required-${requirement.id}-${question_id}`">{{ question_label_by_id(question_id) }}</li>
                              </ul>
                            </div>
                          </div>
                          <details class="context-menu">
                            <summary aria-label="Rule actions"><i class="bi bi-three-dots-vertical"></i></summary>
                            <div class="context-menu-panel">
                              <button type="button" @click="open_conditional_requirement_modal(requirement)">Edit Rule</button>
                              <button type="button" class="text-danger" @click="remove_conditional_onboarding_requirement(requirement.id)">Delete Rule</button>
                            </div>
                          </details>
                        </article>
                        <button v-if="onboarding_conditional_requirements.length > 4" type="button" class="inline-more-button" @click="open_conditional_requirement_modal(onboarding_conditional_requirements[0])">+{{ onboarding_conditional_requirements.length - 4 }} more rule{{ onboarding_conditional_requirements.length - 4 === 1 ? '' : 's' }}</button>
                      </div>
                    </div>
                  </div>
                </section>

              </div>
            </div>
          </section>

          <section v-else-if="active_rule_tab === 'notifications'" class="rule-section card h-100 w-100 border rounded-4 shadow-sm">
            <div class="card-body p-3 p-lg-4">
              <p class="workflow-summary-label mb-1">Notifications & Workflow Triggers</p><h2 class="fw-bold text-x mb-3">Reminder, Alert, and Trigger Settings</h2>
              <div class="row g-3">
                <div class="col-12 col-md-6"><label class="workflow-summary-label mb-1">Workflow Trigger</label><select v-model="selected_workflow_trigger" class="form-select text-xs"><option v-for="trigger in workflow_triggers" :key="trigger">{{ trigger }}</option></select></div>
                <div class="col-12 col-md-6"><label class="workflow-summary-label mb-1">Trigger Source</label><select v-model="selected_trigger_source" class="form-select text-xs"><option v-for="source in entity_sources" :key="source">{{ source }}</option></select></div>
                <div class="col-12 col-md-6"><label class="workflow-summary-label mb-1">Reminder Interval Days</label><input v-model.number="notification_settings.reminder_interval_days" type="number" class="form-control text-xs"></div>
                <div class="col-12 col-md-6 d-flex flex-column gap-2">
                  <div class="form-check form-switch"><input v-model="notification_settings.email_enabled" class="form-check-input" type="checkbox"><label class="form-check-label text-xs">Email notifications</label></div>
                  <div class="form-check form-switch"><input v-model="notification_settings.sms_enabled" class="form-check-input" type="checkbox"><label class="form-check-label text-xs">SMS alerts</label></div>
                  <div class="form-check form-switch"><input v-model="notification_settings.in_app_enabled" class="form-check-input" type="checkbox"><label class="form-check-label text-xs">In-app notifications</label></div>
                </div>
              </div>
              <button type="button"class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" @click="save_notifications">Save Notifications</button>
            </div>
          </section>

          <section v-else-if="active_rule_tab === 'ongoing'" class="rule-section card h-100 w-100 border rounded-4 shadow-sm">
            <div class="card-body p-3 p-lg-4">
              <p class="workflow-summary-label mb-1">Step 6</p><h2 class="fw-bold text-x mb-1">Ongoing Compliance</h2>
              <div class="alert alert-warning py-2 px-3 mt-2 mb-3 text-xs">{{ next_evaluation_label }}</div>
              <p class="text-secondary text-xs mb-3">Ongoing compliance is used after onboarding to check whether the person/entity is still compliant.</p>
              <div class="row g-3 mb-3">
                <div class="col-12 col-md-6">
                  <label class="manual-question-option rounded-3 border p-3 d-flex align-items-start gap-2 mb-0 h-100">
                    <input class="form-check-input mt-1" type="radio" :checked="!Number(rule_form.frequency_days)" @change="enable_onboarding_only_rule()">
                    <span><span class="fw-semibold text-xs d-block">Onboarding-only</span><span class="text-secondary text-xxs">This rule only runs during onboarding and will not re-evaluate on a recurring schedule.</span></span>
                  </label>
                </div>
                <div class="col-12 col-md-6">
                  <label class="manual-question-option rounded-3 border p-3 d-flex align-items-start gap-2 mb-0 h-100">
                    <input class="form-check-input mt-1" type="radio" :checked="Number(rule_form.frequency_days) > 0" @change="rule_form.frequency_days = rule_form.frequency_days || 30">
                    <span><span class="fw-semibold text-xs d-block">Recurring</span><span class="text-secondary text-xxs">This rule re-checks compliance after onboarding using the frequency and recurring grace period.</span></span>
                  </label>
                </div>
              </div>
              <div class="row g-3">
                <div class="col-12 col-md-4"><label class="workflow-summary-label mb-1">Frequency Days</label><input v-model.number="rule_form.frequency_days" type="number" min="0" class="form-control text-xs"></div>
                <div class="col-12 col-md-4"><label class="workflow-summary-label mb-1">Initial Grace Days</label><input v-model.number="rule_form.initial_grace_period_days" type="number" min="0" class="form-control text-xs"></div>
                <div class="col-12 col-md-4"><label class="workflow-summary-label mb-1">Recurring Grace Days</label><input v-model.number="rule_form.recurring_grace_period_days" type="number" min="0" class="form-control text-xs"></div>
              </div>
              <div class="d-flex gap-2 flex-wrap mt-3">
                <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" :disabled="saving" @click="save_rule_setup_step">Save Ongoing Settings</button>
              </div>
            </div>
          </section>

          <section v-else-if="active_rule_tab === 'review_publish'" class="rule-section card h-100 w-100 border rounded-4 shadow-sm">
            <div class="card-body p-3 p-lg-4">
              <p class="workflow-summary-label mb-1">Step 7</p><h2 class="fw-bold text-x mb-1">Review & Publish</h2><p class="text-secondary text-xs mb-3">Review the configuration, clear validation blockers, and publish this compliance rule.</p>
              <div class="alert alert-primary py-2 px-3 mb-3 text-xs">This rule will first check onboarding-required questions. If complete, it will evaluate compliance conditions and run the configured actions. If recurring is enabled, it will also re-check compliance after onboarding.</div>
              <div class="alert alert-info py-2 px-3 mb-3 text-xs">Compliance status is shown separately from overall onboarding completion unless backend completion rules include it.</div>
              <div class="row g-2 mb-3">
                <div v-for="metric in rule_summary_cards" :key="metric.label" class="col-6 col-md-4">
                  <div class="metric-tile rounded-4 border p-3 h-100"><p class="workflow-summary-label mb-1">{{ metric.label }}</p><p class="fw-bold text-xs mb-0">{{ metric.value }}</p></div>
                </div>
              </div>
              <div class="row g-3 mb-3">
                <div class="col-12 col-xl-6">
                  <div class="metric-tile rounded-4 border p-3 h-100">
                    <p class="workflow-summary-label mb-2">Rule Summary</p>
                    <p class="fw-bold text-xs mb-1">{{ selected_rule?.name || rule_form.name || 'Untitled Rule' }}</p>
                    <p class="text-secondary text-xxs mb-0">{{ selected_rule?.trigger_status_label || 'Trigger status not selected' }} | {{ selected_rule?.logic || rule_form.logical_operator || 'Logic not selected' }}</p>
                  </div>
                </div>
                <div class="col-12 col-xl-6">
                  <div class="metric-tile rounded-4 border p-3 h-100">
                    <p class="workflow-summary-label mb-2">Ongoing Compliance Settings</p>
                    <p class="fw-bold text-xs mb-1">{{ Number(rule_form.frequency_days || selected_rule?.frequency_days) > 0 ? 'Recurring' : 'Onboarding Only' }}</p>
                    <p class="text-secondary text-xxs mb-0">{{ next_evaluation_label }}</p>
                  </div>
                </div>
                <div class="col-12">
                  <div class="metric-tile rounded-4 border p-3 h-100">
                    <p class="workflow-summary-label mb-2">Onboarding Gate</p>
                    <p class="fw-bold text-xs mb-1">{{ onboarding_required_selection_label }}</p>
                    <p class="text-secondary text-xxs mb-0">{{ onboarding_conditional_requirements.length }} conditional required field{{ onboarding_conditional_requirements.length === 1 ? '' : 's' }} configured.</p>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center gap-2 flex-wrap mb-3">
                <div>
                  <p class="workflow-summary-label mb-1">Assigned Question Review</p>
                  <p class="text-secondary text-xxs mb-0">{{ selected_rule_forms.length }} form{{ selected_rule_forms.length === 1 ? '' : 's' }} and {{ selected_rule_questions.length }} question{{ selected_rule_questions.length === 1 ? '' : 's' }} available to this rule.</p>
                </div>
                <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" @click="show_bootstrap_modal('assigned_questions_review_modal')">
                  <i class="bi bi-ui-checks-grid me-1"></i>View Assigned Questions
                </button>
              </div>
              <div class="row g-3 mb-3 align-items-start">
                <div class="col-12 col-lg-6">
                  <p class="workflow-summary-label mb-2">Condition Groups</p>
                  <div class="d-flex flex-column gap-2">
                    <div v-for="group in condition_groups.slice(0, 4)" :key="`review-condition-${group.id || group.name}`" class="condition-row d-flex justify-content-between align-items-center gap-2">
                      <span class="text-xs">{{ group.name || group.group_name || 'Condition Group' }}</span>
                      <span class="badge rounded-pill bg-light text-dark border">{{ (group.conditions || []).length }} condition(s)</span>
                    </div>
                    <div v-if="!condition_groups.length" class="condition-row text-secondary text-xs">No condition groups configured.</div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <p class="workflow-summary-label mb-2">Actions</p>
                  <div class="d-flex flex-column gap-2">
                    <div v-for="action in configured_actions.filter((item) => item.enabled).slice(0, 4)" :key="`review-action-${action.id || action.result || action.action}`" class="condition-row d-flex justify-content-between align-items-center gap-2">
                      <span class="text-xs">{{ action.result || action.label || 'Result Action' }}</span>
                      <span class="badge rounded-pill bg-light text-dark border">{{ action.action || action.action_type }}</span>
                    </div>
                    <div v-if="!actions_complete" class="condition-row text-secondary text-xs">No actions configured.</div>
                  </div>
                </div>
                <div class="col-12 review-validation-section">
                  <div class="d-flex justify-content-between align-items-center gap-2 mb-2">
                    <p class="workflow-summary-label mb-0">Validation Checklist</p>
                    <span class="badge rounded-pill" :class="publication_readiness_class">{{ publication_readiness_label }}</span>
                  </div>
                  <div class="review-validation-grid">
                    <div v-for="check in validation_checks" :key="check.label" class="condition-row d-flex justify-content-between align-items-center gap-2">
                      <span class="text-xs"><i class="bi me-1" :class="check.ok ? 'bi-check-circle-fill text-success' : 'bi-exclamation-triangle-fill text-warning'"></i>{{ check.label }}</span>
                      <span class="badge rounded-pill" :class="validation_badge_class(check)">{{ check.ok ? 'Ready' : check.severity === 'critical' ? 'Missing' : 'Warning' }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="test_result_cards.length" class="d-flex flex-wrap gap-2 mb-3">
                <span v-for="card in test_result_cards" :key="card.label" class="badge rounded-pill bg-light text-dark border">{{ card.label }}: {{ card.value }}</span>
              </div>
            </div>
          </section>
        </div>
      </main>

      <aside class="col-12 col-xl-4 d-flex flex-column gap-3 compliance_sidebar_column">
        <div class="card w-100 border rounded-4 shadow-sm support-panel">
          <div class="card-body p-3">
            <div class="support-progress-row mb-2">
              <p class="workflow-summary-label mb-0">Setup Progress</p>
              <span class="text-secondary text-xxs">{{ completed_setup_steps_count }} of {{ setup_steps.length }} complete</span>
            </div>
            <div class="d-flex flex-column gap-2">
              <button
                v-for="step in setup_steps"
                :key="`sidebar-step-${step.id}`"
                type="button"
                class="compliance_progress_step"
                :class="{
                  compliance_progress_step_active: active_rule_tab === step.id,
                  compliance_progress_step_locked: !step.unlocked
                }"
                :disabled="!step.unlocked"
                @click="set_active_rule_tab(step.id)"
              >
                <div class="d-flex align-items-center justify-content-between gap-2">
                  <span class="compliance_progress_label text-xs">
                    <i class="bi me-1" :class="step.complete ? 'bi-check-circle-fill' : step.unlocked ? 'bi-circle' : 'bi-lock'"></i>{{ step.label }}
                  </span>
                  <span class="badge rounded-pill text-xxs" :class="step_badge_class(step.status)">{{ step.status }}</span>
                </div>
                <span v-if="active_rule_tab === step.id" class="text-secondary text-xxs d-block mt-1">Current Step</span>
              </button>
            </div>
          </div>
        </div>

        <div class="card w-100 border rounded-4 shadow-sm support-panel">
          <div class="card-body p-3">
            <div class="d-flex justify-content-between align-items-center gap-2 mb-2">
              <p class="workflow-summary-label mb-0">Configuration Health</p>
              <span class="badge rounded-pill" :class="publication_readiness_class">{{ publication_readiness_label }}</span>
            </div>
            <p class="fw-bold text-xs mb-2">{{ publish_readiness_score }}% Complete</p>
            <div class="health-progress-track mb-2">
              <div class="health-progress-fill" :class="configuration_health_class" :style="{ width: `${publish_readiness_score}%` }"></div>
            </div>
            <p class="text-secondary text-xxs mb-2">{{ missing_setup_requirements.length }} required task{{ missing_setup_requirements.length === 1 ? '' : 's' }} remaining</p>
            <div v-if="missing_setup_requirements.length" class="d-flex flex-column gap-1">
              <span v-for="requirement in missing_setup_requirements.slice(0, 4)" :key="requirement" class="guidance-mini-item">{{ requirement }}</span>
            </div>
          </div>
        </div>

        <div v-if="sidebar_validation_items.length" class="card w-100 border rounded-4 shadow-sm support-panel">
          <div class="card-body p-3">
            <p class="workflow-summary-label mb-2">Validation Warnings</p>
            <div class="d-flex flex-column gap-2">
              <div v-for="item in sidebar_validation_items" :key="`${item.severity}-${item.label}`" class="compact-warning text-xxs" :class="`compact-warning-${item.severity}`">
                <span class="guidance-severity-label">{{ item.severity }}</span>
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card w-100 border rounded-4 shadow-sm support-panel next-step-panel">
          <div class="card-body p-3">
            <p class="workflow-summary-label mb-1">Next Recommended Step</p>
            <h3 class="fw-bold text-xs mb-1">{{ sidebar_next_step.title }}</h3>
            <p class="text-secondary text-xxs mb-3">{{ sidebar_next_step.description }}</p>
            <button v-if="active_rule_tab !== 'review_publish'" type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1 w-100" :disabled="sidebar_next_step.disabled" @click="set_active_rule_tab(sidebar_next_step.target)">{{ sidebar_next_step.button }}</button>
          </div>
        </div>
      </aside>

      </div>
      </div>

    </section>

    <section v-else class="card border rounded-4 shadow-sm">
      <div class="card-body p-5 text-center"><p class="fw-bold text-xs mb-1">No rule selected</p><p class="text-secondary text-xs mb-3">Return to the rules hub and open a compliance rule.</p><button type="button" class="btn btn-primary-dark btn-sm rounded-3 text-xs" @click="open_hub">Back to Rules Hub</button></div>
    </section>
  </div>

  <teleport to="body">
    <div class="modal fade" id="compliance_rule_modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg"><p class="modal-title text-white text-xs mb-0">{{ rule_form.mode === 'edit' ? 'Edit Compliance Rule' : 'Create Compliance Rule' }}</p><button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div>
          <div class="modal-body modal-scroll-body">
            <div class="row g-2">
              <div class="col-12 col-md-6"><label class="modal-form-label form-label text-xs">Rule Name</label><input v-model="rule_form.name" type="text" class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm" placeholder="Please enter a compliance rule name"></div>
              <div class="col-12 col-md-6"><label class="modal-form-label form-label text-xs">Logic</label><select v-model="rule_form.logical_operator" class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"><option v-for="operator in operators" :key="operator">{{ operator }}</option></select></div>
              <div class="col-12"><label class="modal-form-label form-label text-xs">Description</label><textarea v-model="rule_form.description" rows="3" class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm" placeholder="Please enter a compliance rule description"></textarea></div>
              <div class="col-12 col-md-6"><label class="modal-form-label form-label text-xs">Trigger Status</label><select v-model="rule_form.trigger_status_id" class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"><option value="">Select trigger status</option><option v-for="status in form_statuses" :key="status.id" :value="String(status.id)">{{ status.status || status.name || `Status ${status.id}` }}</option></select></div>
              <div class="col-12 col-md-6"><label class="modal-form-label form-label text-xs">Status</label><select v-model="rule_form.status" class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"><option>Draft</option><option>Active</option></select><small class="text-secondary text-xxs">Backend derives active behavior from trigger status.</small></div>
              <div class="col-12 col-md-4"><label class="modal-form-label form-label text-xs">Initial Grace Days</label><input v-model.number="rule_form.initial_grace_period_days" type="number" min="0" class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm" placeholder="e.g. 7"></div>
              <div class="col-12 col-md-4"><label class="modal-form-label form-label text-xs">Frequency Days</label><input v-model.number="rule_form.frequency_days" type="number" min="0" class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm" placeholder="Leave blank for onboarding only"></div>
              <div class="col-12 col-md-4"><label class="modal-form-label form-label text-xs">Recurring Grace</label><input v-model.number="rule_form.recurring_grace_period_days" type="number" min="0" class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm" placeholder="e.g. 14"></div>
            </div>
            <small v-if="modal_error_message" class="text-danger p-2 text-xs fw-bold d-block">{{ modal_error_message }}</small>
          </div>
          <div class="modal-footer border-0 p-2 d-flex justify-content-end gap-2"><button type="button"  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" data-bs-dismiss="modal">Cancel</button><button type="button"
              class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" :disabled="saving" @click="save_rule">{{ saving ? 'Saving...' : 'Save Rule' }}</button></div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="condition_group_modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <div>
              <p class="modal-title text-white text-xs mb-0">Add Condition Group</p>
              <p class="text-white-50 text-xxs mb-0">Use questions assigned in Forms &amp; Questions.</p>
            </div>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="!selected_rule_questions.length" class="subtle-empty-state rounded-4 text-center text-secondary text-xs">Assign forms and questions before creating conditions.</div>
            <div v-else class="d-flex flex-column gap-3">
              <div class="row g-3">
                <div class="col-12 col-md-8">
                  <label class="modal-form-label form-label text-xs">Group Name</label>
                  <input v-model="condition_group_form.name" type="text" class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm" placeholder="Group 1">
                </div>
                <div class="col-12 col-md-4">
                  <label class="modal-form-label form-label text-xs">Group Logic</label>
                  <select v-model="condition_group_form.logic" class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm">
                    <option>AND</option>
                    <option>OR</option>
                  </select>
                </div>
              </div>

              <div class="d-flex flex-column gap-3">
                <article v-for="condition in condition_group_form.conditions" :key="condition.id" class="condition-row condition-row-enterprise">
                  <div class="row g-3 align-items-start">
                    <div class="col-12 col-md-6 col-xl-3">
                      <label class="workflow-summary-label mb-1">Assigned Form</label>
                      <select v-model="condition.form_id" class="form-select text-xs" :class="{ 'is-invalid': condition_row_invalid(condition, 'form_id') }" @change="update_condition_form(condition)">
                        <option value="" disabled>Select assigned form</option>
                        <option v-for="form in selected_rule_forms" :key="form.form_id" :value="String(form.form_id)">{{ form.form_name }}</option>
                      </select>
                      <div class="invalid-feedback">Select an assigned form.</div>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4">
                      <div class="d-flex justify-content-between align-items-center gap-2 mb-1">
                        <label class="workflow-summary-label mb-0">Assigned Questions</label>
                        <button type="button" class="btn btn-link btn-sm text-xs p-0" :disabled="!condition.form_id || !selected_form_has_condition_questions(condition)" @click="toggle_all_condition_questions(condition)">{{ all_condition_questions_selected(condition) ? 'Clear All' : 'Select All' }}</button>
                      </div>
                      <div class="dropdown w-100">
                        <button
                          type="button"
                          class="form-select text-xs text-start condition-question-picker-btn"
                          :class="{ 'is-invalid': condition_row_invalid(condition, 'question_id') }"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                          :disabled="!condition.form_id || !selected_form_has_condition_questions(condition)"
                        >
                          {{ condition_question_picker_label(condition) }}
                        </button>
                        <div class="dropdown-menu w-100 p-2 condition-question-dropdown">
                          <label
                            v-for="question in questions_for_condition(condition)"
                            :key="question.section_question_id || question.id"
                            class="dropdown-item text-xs d-flex align-items-center gap-2 mb-0"
                          >
                            <input
                              v-model="condition.assigned_question_ids"
                              class="form-check-input m-0"
                              type="checkbox"
                              :value="String(question.section_question_id || question.id)"
                              @change="update_condition_question(condition)"
                            >
                            <span>{{ question.question_text }}</span>
                          </label>
                        </div>
                      </div>
                      <div class="invalid-feedback">Select at least one assigned question.</div>
                      <small class="text-secondary text-xxs d-block mt-1">{{ condition_selected_question_ids(condition).length }} selected</small>
                      
                    </div>
                    <div class="col-12 col-md-6 col-xl-2">
                      <label class="workflow-summary-label mb-1">Operator</label>
                      <select v-model="condition.operator" class="form-select text-xs" :class="{ 'is-invalid': condition_row_invalid(condition, 'operator') }">
                        <option v-for="operator in get_condition_operators(condition)" :key="operator">{{ operator }}</option>
                      </select>
                      <div class="invalid-feedback">Select an operator.</div>
                    </div>
                    <div class="col-10 col-md-5 col-xl-2">
                      <label class="workflow-summary-label mb-1">Comparison Value</label>
                      <select v-if="is_boolean_condition(condition)" v-model="condition.value" class="form-select text-xs" :class="{ 'is-invalid': condition_row_invalid(condition, 'value') }" :disabled="!condition_operator_requires_value(condition.operator)">
                        <option value="" disabled>Select value</option>
                        <option>Yes</option>
                        <option>No</option>
                      </select>
                      <input v-else v-model="condition.value" :type="condition_value_input_type(condition)" class="form-control text-xs" :class="{ 'is-invalid': condition_row_invalid(condition, 'value') }" :disabled="!condition_operator_requires_value(condition.operator)" :placeholder="condition_operator_requires_value(condition.operator) ? 'Value' : 'No value required'">
                      <div class="invalid-feedback">Enter a comparison value for this operator.</div>
                    </div>
                    <div class="col-1 col-md-1 col-xl-1 text-end mt-4">
                      <button type="button" class="btn btn-outline-danger btn-sm rounded-circle " @click="remove_condition_group_row(condition.id)"><i class="bi bi-trash"></i></button>
                      <button type="button" class="btn entity-assign-btn btn-sm rounded-circle py-2 ms-2" @click="update_condition_group_modal"><i class="bi bi-pencil"></i></button>
                    </div>
                  </div>
                  <div class="d-flex flex-wrap gap-2 mt-2">
                    <span v-if="condition.form_id" class="badge rounded-pill bg-light text-dark border">Form ID: {{ condition.form_id }}</span>
                    <span v-if="condition_selected_question_ids(condition).length" class="badge rounded-pill bg-primary-subtle text-primary">{{ condition_selected_question_ids(condition).length }} question(s) selected</span>
                    <span v-if="condition.compliance_field_id" class="badge rounded-pill bg-light text-dark border">Compliance Field ID: {{ condition.compliance_field_id }}</span>
                  </div>
                </article>
              </div>
              <button type="button" class="btn entity-panel-btn btn-sm rounded-small text-xs d-inline-flex align-items-center gap-2 px-3 py-2 align-self-start" @click="add_condition_group_row"><i class="bi bi-plus-lg"></i>Add Row</button>
            </div>
          </div>
          <div class="modal-footer border-0 p-2 d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-outline-secondary btn-sm rounded-small text-xs" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" :disabled="!selected_rule_questions.length" @click="save_condition_group_modal">Add Condition Group</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="action_config_modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xs mb-0">{{ action_form.mode === 'edit' ? 'Edit Action' : 'Add Action' }}</p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <label class="modal-form-label form-label text-xs">Outcome Type</label>
                <select v-model="action_form.outcome_type" class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm">
                  <option value="pass">Pass</option>
                  <option value="fail">Fail</option>
                  <option value="manual_review">Manual Review</option>
                  <option value="expired">Expired</option>
                  <option value="missing_data">Missing Data</option>
                </select>
              </div>
              <div class="col-12 col-md-6">
                <label class="modal-form-label form-label text-xs">Action Type</label>
                <select v-model="action_form.action_type" class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm">
                  <option>Approve</option>
                  <option>Reject</option>
                  <option>Manual Review</option>
                  <option>Escalate</option>
                  <option>Create Audit Log</option>
                </select>
              </div>
              <div class="col-12">
                <label class="modal-form-label form-label text-xs">Description</label>
                <textarea v-model="action_form.description" rows="3" class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm" placeholder="Describe what should happen when this outcome is returned."></textarea>
              </div>
              <div class="col-12">
                <label class="modal-form-label form-label text-xs">Target Status</label>
                <select v-model="action_form.target_status" class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm">
                  <option value="" disabled>Select target status</option>
                  <option v-for="status in action_target_status_options" :key="status" :value="status">{{ status }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 p-2 d-flex justify-content-end gap-2">
            <button type="button"  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" data-bs-dismiss="modal">Cancel</button>
            <button type="button"  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" @click="save_action_modal">Save Action</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="required_questions_modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable compliance-drawer-modal">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <div>
              <p class="modal-title text-white text-xs mb-0">Manage Required Questions</p>
              <p class="text-white-50 text-xxs mb-0">{{ required_question_modal_summary }}</p>
            </div>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body modal-scroll-body">
            <div v-if="!selected_rule_questions.length" class="subtle-empty-state rounded-4 text-center text-secondary text-xs">Assign forms and questions first.</div>
            <div v-else class="required-modal-flow">
              <label class="select-all-row">
                <input class="form-check-input m-0" type="checkbox" :checked="all_assigned_required_questions_selected" :indeterminate="some_assigned_required_questions_selected" @change="toggle_all_required_modal_questions">
                <span><span class="fw-semibold text-xs d-block">Select All Questions</span><span class="text-secondary text-xxs">{{ required_question_modal_summary }}</span></span>
              </label>
              <div class="question-filter-bar required-question-filter-bar">
                <input v-model="required_question_modal.search" class="form-control form-control-sm text-xs" placeholder="Search questions">
              </div>

              <div class="d-flex justify-content-between align-items-center gap-2 flex-wrap">
                <span class="badge rounded-pill bg-light text-dark border">{{ filtered_required_modal_questions.length }} matching question{{ filtered_required_modal_questions.length === 1 ? '' : 's' }}</span>
                <button type="button" class="btn btn-outline-secondary btn-sm rounded-3 text-xs" @click="clear_all_required_questions">Clear Selection</button>
              </div>

              <div v-if="!filtered_required_modal_questions.length" class="subtle-empty-state rounded-4 text-center text-secondary text-xs">No questions match your search.</div>
              <div v-else class="compact-question-list">
                <div v-for="group in required_modal_question_groups" :key="`required-modal-group-${group.name}`" class="question-accordion">
                  <button type="button" class="question-accordion-toggle" @click="toggle_required_modal_section(group.name)">
                    <span><i class="bi me-2" :class="group.expanded ? 'bi-chevron-down' : 'bi-chevron-right'"></i>{{ group.name }}</span>
                    <span class="badge rounded-pill bg-primary-subtle text-primary">{{ group.selected_count }} selected</span>
                  </button>
                  <div v-if="group.expanded" class="question-accordion-rows">
                <label v-for="question in group.questions" :key="`required-modal-${question_key(question)}`" class="compact-question-row">
                  <input class="form-check-input m-0" type="checkbox" :checked="required_question_modal.working_ids.includes(question_key(question))" @change="toggle_required_modal_question(question_key(question))">
                  <span class="compact-question-copy">
                    <span class="compact-question-title" :title="question.question_text">{{ question.question_text }}</span>
                    <span class="compact-question-meta">{{ question.form_name }} | {{ question.section_name || 'Section' }} | {{ question_type_label(question) }}</span>
                  </span>
                </label>
                  </div>
                </div>
                <div v-if="has_more_required_modal_questions" class="text-center pt-2">
                  <button type="button" class="btn entity-panel-btn btn-sm rounded-3 text-xs" @click="load_more_required_modal_questions">Load More Questions</button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer sticky-modal-footer border-0 p-2 d-flex justify-content-between gap-2">
            <span class="text-secondary text-xxs">{{ required_question_modal_summary }}</span>
            <div class="d-flex gap-2">
              <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" @click="save_required_questions_modal">Save Changes</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="conditional_requirement_modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable compliance-drawer-modal">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <div>
              <p class="modal-title text-white text-xs mb-0">{{ conditional_requirement_form.id ? 'Edit Conditional Question' : 'Add Conditional Question' }}</p>
              <p class="text-white-50 text-xxs mb-0">Require extra questions when a specific answer is selected.</p>
            </div>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body modal-scroll-body">
            <div v-if="selected_rule_questions.length < 2" class="subtle-empty-state rounded-4 text-center text-secondary text-xs">Assign at least two questions before adding a conditional question.</div>
            <div v-else class="conditional-question-flow">
              <section class="conditional-flow-section">
                <p class="conditional-flow-title mb-2">When applicant answers</p>
              <div class="conditional-search-select">
                <input
                  v-model="conditional_question_search"
                  class="form-control text-xs"
                  placeholder="Search and select a question"
                  @focus="conditional_question_picker_open = true"
                  @input="conditional_question_picker_open = true"
              
                >
                <button type="button" class="conditional-search-toggle" @mousedown.prevent="conditional_question_picker_open = !conditional_question_picker_open">
                  <i class="bi bi-chevron-down"></i>
                </button>
                <div v-if="conditional_question_picker_open" class="conditional-search-menu">
                  <button
                    v-for="question in conditional_question_search_results"
                    :key="`conditional-trigger-${question_key(question)}`"
                    type="button"
                    class="conditional-search-option"
                    :class="{ active: conditional_requirement_form.trigger_question_id === question_key(question) }"
                    @mousedown.prevent="set_conditional_trigger_question(question_key(question))"
                  >
                    <span>{{ question.question_text }}</span>
                    <small>{{ question.section_name || 'Section' }} | {{ question_type_label(question) }}</small>
                  </button>
                  <div v-if="!conditional_question_search_results.length" class="conditional-search-empty">No questions match your search.</div>
                </div>
              </div>

              </section>

              <section class="conditional-flow-section">
                <p class="conditional-flow-title mb-2">With this answer</p>
                <div v-if="conditional_trigger_uses_options && conditional_trigger_answer_options.length" class="conditional-option-grid">
                  <label v-for="option in conditional_trigger_answer_options" :key="`trigger-answer-${option}`" class="conditional-option-row" :class="{ active: conditional_requirement_form.trigger_value === option }">
                    <input class="form-check-input m-0" type="radio" :checked="conditional_requirement_form.trigger_value === option" @change="set_conditional_trigger_answer(option)">
                    <span>{{ option }}</span>
                  </label>
                </div>
                <div v-else class="conditional-text-answer-row">
                  <select v-model="conditional_requirement_form.operator" class="form-select form-select-sm text-xs">
                    <option value="=">equals</option>
                    <option value="contains">contains</option>
                  </select>
                  <input v-model="conditional_requirement_form.trigger_value" class="form-control form-control-sm text-xs" placeholder="Type the answer">
                </div>
              </section>

              <section class="conditional-flow-section">
                <div class="d-flex justify-content-between align-items-center gap-2 mb-2">
                  <div>
                    <p class="conditional-flow-title mb-1">Also require these questions</p>
                    <p class="text-secondary text-xxs mb-0">Choose follow-up questions applicants must answer.</p>
                  </div>
                  <span class="badge rounded-pill bg-primary-subtle text-primary">{{ conditional_requirement_form.required_question_ids.length }} selected</span>
                </div>
                <div class="compact-question-list compact-question-list-short">
                  <label v-for="question in conditional_required_question_options" :key="`conditional-dependent-${question_key(question)}`" class="compact-question-row conditional-question-row">
                    <input class="form-check-input m-0" type="checkbox" :checked="conditional_requirement_form.required_question_ids.includes(question_key(question))" @change="toggle_conditional_form_required_question(question_key(question))">
                    <span class="compact-question-copy">
                      <span class="compact-question-title" :title="question.question_text">{{ question.question_text }}</span>
                      <span class="compact-question-meta">{{ question.section_name || 'Section' }} | {{ question_type_label(question) }}</span>
                    </span>
                  </label>
                </div>
              </section>

              <section class="conditional-preview-card">
                <p class="conditional-flow-title mb-2">Preview</p>
                <p class="text-xs mb-2">When applicant selects: <strong>{{ conditional_requirement_form.trigger_value || 'an answer' }}</strong></p>
                <p class="text-secondary text-xxs mb-1">Also require:</p>
                <ul class="question-bullet-preview mb-0">
                  <li v-for="label in conditional_preview_required_labels" :key="`conditional-preview-${label}`">{{ label }}</li>
                  <li v-if="!conditional_preview_required_labels.length">No follow-up questions selected</li>
                </ul>
              </section>
            </div>
          </div>
          <div class="modal-footer sticky-modal-footer border-0 p-2 d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-outline-secondary btn-sm rounded-small text-xs" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" :disabled="!conditional_requirement_form.trigger_question_id || !conditional_requirement_form.trigger_value || !conditional_requirement_form.required_question_ids.length" @click="save_conditional_requirement_modal">Save Conditional Question</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="assigned_questions_review_modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable compliance-drawer-modal">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <div>
              <p class="modal-title text-white text-xs mb-0">Assigned Questions</p>
              <p class="text-white-50 text-xxs mb-0">{{ selected_rule_forms.length }} form{{ selected_rule_forms.length === 1 ? '' : 's' }} | {{ selected_rule_questions.length }} question{{ selected_rule_questions.length === 1 ? '' : 's' }}</p>
            </div>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-12 col-lg-5">
                <p class="workflow-summary-label mb-2">Assigned Forms</p>
                <div class="d-flex flex-column gap-2">
                  <div v-for="form in selected_rule_forms" :key="`review-modal-form-${form.id || form.form_id}`" class="condition-row d-flex justify-content-between align-items-center gap-2">
                    <span class="text-xs">{{ form.name || form.form_name || form.label }}</span>
                    <span class="badge rounded-pill bg-light text-dark border">{{ form.assignment_method_label || 'Assigned' }}</span>
                  </div>
                  <div v-if="!selected_rule_forms.length" class="condition-row text-secondary text-xs">No forms assigned.</div>
                </div>
              </div>
              <div class="col-12 col-lg-7">
                <p class="workflow-summary-label mb-2">Selected Questions</p>
                <div class="d-flex flex-column gap-2">
                  <div v-for="question in selected_rule_questions" :key="`review-modal-question-${question_key(question)}`" class="condition-row d-flex justify-content-between align-items-center gap-2">
                    <span class="text-xs">{{ question.question_text || question.label || question.name }}</span>
                    <span class="badge rounded-pill bg-light text-dark border">{{ question_type_label(question) }}</span>
                  </div>
                  <div v-if="!selected_rule_questions.length" class="condition-row text-secondary text-xs">No questions selected.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer sticky-modal-footer border-0 p-2 d-flex justify-content-end">
            <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="assignment_questions_modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable compliance-drawer-modal">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <div>
              <p class="modal-title text-white text-xs mb-0">Manage Questions &mdash; {{ assignment_modal_form ? assignment_modal_form.form_name : 'Selected Form' }}</p>
              <p class="text-white-50 text-xxs mb-0">{{ assignment_modal_selected_count }} selected of {{ assignment_modal_form_questions.length }} available - {{ assignment_modal_mode_label }}</p>
            </div>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="loading_manual_questions" class="d-flex align-items-center gap-2 text-secondary text-xs py-3">
              <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div><span>Loading questions...</span>
            </div>
            <div v-else>
              <div class="d-flex flex-column gap-3">
                <div class="question-preview-panel rounded-4 p-3">
                  <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-2">
                    <div>
                      <p class="workflow-summary-label mb-1">Assignment Mode</p>
                      <p class="text-secondary text-xxs mb-0">Choose whether this rule uses every question or a curated set from this form.</p>
                    </div>
                    <span class="badge rounded-pill bg-primary-subtle text-primary px-3 py-2">{{ assignment_modal_mode_label }}</span>
                  </div>
                  <div class="row g-2">
                  <div class="col-12 col-md-6">
                    <label class="manual-question-option rounded-3 border p-2 d-flex align-items-start gap-2 mb-0 h-100">
                      <input v-model="assignment_question_modal.method" class="form-check-input mt-1" type="radio" value="full_form" @change="set_assignment_modal_method('full_form')">
                      <span><span class="fw-semibold text-xs d-block">Assign all questions</span><span class="text-secondary text-xxs">Every question in this form applies to the rule.</span></span>
                    </label>
                  </div>
                  <div class="col-12 col-md-6">
                    <label class="manual-question-option rounded-3 border p-2 d-flex align-items-start gap-2 mb-0 h-100">
                      <input v-model="assignment_question_modal.method" class="form-check-input mt-1" type="radio" value="manual" @change="set_assignment_modal_method('manual')">
                      <span><span class="fw-semibold text-xs d-block">Select specific questions</span><span class="text-secondary text-xxs">Choose only the fields this rule should evaluate.</span></span>
                    </label>
                  </div>
                  </div>
                </div>

                <div v-if="assignment_question_modal.method === 'full_form'" class="subtle-empty-state rounded-4 text-center text-secondary text-xs">All questions from this form are included automatically.</div>

                <div class="question-filter-bar">
                  <input v-model="assignment_question_modal.question_search" class="form-control form-control-sm text-xs" placeholder="Search questions">
                  <select v-model="assignment_question_modal.section_filter" class="form-select form-select-sm text-xs">
                    <option value="">All sections</option>
                    <option v-for="section in assignment_modal_section_filters" :key="section" :value="section">{{ section }}</option>
                  </select>
                  <select v-model="assignment_question_modal.answer_type_filter" class="form-select form-select-sm text-xs">
                    <option value="">All answer types</option>
                    <option v-for="type in assignment_modal_answer_type_filters" :key="type.value" :value="type.value">{{ type.label }}</option>
                  </select>
                  <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" @click="clear_assignment_modal_filters">Clear Search</button>
                </div>

                <div class="d-flex justify-content-between align-items-center gap-2 flex-wrap">
                  <span class="badge rounded-pill bg-light text-dark border">{{ assignment_modal_filtered_total_count }} matching question{{ assignment_modal_filtered_total_count === 1 ? '' : 's' }}</span>
                  <div v-if="assignment_question_modal.method === 'manual'" class="d-flex flex-wrap gap-2">
                    <button type="button" class="btn entity-panel-btn btn-sm rounded-3 text-xs" @click="select_all_assignment_modal_questions">Select All Visible</button>
                    <button type="button" class="btn entity-panel-btn btn-sm rounded-3 text-xs" @click="clear_assignment_modal_questions">Clear Visible</button>
                    <button type="button" class="btn entity-panel-btn btn-sm rounded-3 text-xs" @click="select_all_filtered_assignment_questions">Select All Filtered</button>
                  </div>
                </div>

                <div class="question-section-list">
                  <article v-for="section in assignment_modal_form_sections" :key="`modal-section-${section.id}`" class="question-section-accordion">
                    <button type="button" class="question-section-toggle" @click="toggle_assignment_modal_section(section)">
                      <span><i class="bi me-2" :class="assignment_modal_section_expanded(section) ? 'bi-chevron-down' : 'bi-chevron-right'"></i>{{ section.section_name }}</span>
                      <span class="badge rounded-pill bg-primary-subtle text-primary">{{ section.selected_count }} selected</span>
                    </button>
                    <div v-if="assignment_question_modal.method === 'manual' && assignment_modal_section_expanded(section)" class="d-flex gap-2 flex-wrap px-2 pb-2">
                      <button type="button" class="btn btn-link btn-sm text-xs p-0" @click="select_assignment_modal_section(section.section_name)">Select Section</button>
                      <button type="button" class="btn btn-link btn-sm text-xs p-0 text-secondary" @click="clear_assignment_modal_section(section.section_name)">Clear Section</button>
                    </div>
                    <div v-if="assignment_modal_section_expanded(section)" class="question-section-rows">
                        <label v-for="question in section.questions" :key="question.section_question_id" class="compact-question-row">
                          <input
                            v-if="assignment_question_modal.method === 'manual'"
                            v-model="assignment_question_modal.selected_question_ids"
                            class="form-check-input m-0"
                            type="checkbox"
                            :value="String(question.section_question_id)"
                          >
                          <input
                            v-else
                            class="form-check-input m-0"
                            type="checkbox"
                            checked
                            disabled
                          >
                          <span class="compact-question-copy">
                            <span class="compact-question-title" :title="question.question_text">{{ question.question_text }}</span>
                            <span class="compact-question-meta">{{ section.section_name }} - {{ question_type_label(question) }}</span>
                          </span>
                        </label>
                    </div>
                  </article>
                  <div v-if="!assignment_modal_form_sections.length" class="subtle-empty-state rounded-4 text-center text-secondary text-xs">No questions match your filters.</div>
                  <div v-if="assignment_modal_has_more_filtered_questions" class="text-center pt-2">
                    <button type="button" class="btn entity-panel-btn btn-sm rounded-3 text-xs" @click="load_more_assignment_modal_questions">Load More Questions</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer sticky-modal-footer border-0 p-2 d-flex justify-content-between gap-2">
            <span class="text-secondary text-xxs">{{ assignment_modal_selected_count }} selected - {{ assignment_modal_form_questions.length }} available</span>
            <div class="d-flex gap-2">
              <button type="button"  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" data-bs-dismiss="modal">Cancel</button>
              <button type="button"  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" :disabled="assigning || loading_manual_questions || (assignment_question_modal.method === 'manual' && !assignment_question_modal.selected_question_ids.length)" @click="save_assignment_question_modal">
                {{ assigning ? 'Saving...' : 'Save Changes' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </teleport>
</div>
